export enum UserRole {
    Admin = 1,
    Customer = 2,
    Advisor = 3,
    CrmManager = 4,
    Accounting = 5,
}

export const UserRoleLabelMapping: Record<UserRole, string> = {
    [UserRole.Admin]: 'Admin',
    [UserRole.Customer]: 'Customer',
    [UserRole.Advisor]: 'Advisor',
    [UserRole.CrmManager]: 'CRM Manager',
    [UserRole.Accounting]: 'Accounting',
};
